import axios from "axios";
import {CampaignTemplate} from "@src/types/CampaignTemplate";

class WaapiService {
    async getTemplates(channelId: number): Promise<CampaignTemplate[]> {
        const {data} = await axios.get(`/operator/v4/waapi/templates/${channelId}`);
        return data;
    }

    async fetchCoordinates(address: string): Promise<any> {
        const {data} = await axios.get(`/operator/v4/waapi/get-coordinates/${encodeURIComponent(address)}`);
        return data;
    }

    async saveCampaign(campaign: FormData) {
        const {data} = await axios.post('/operator/v4/waapi/campaign', campaign, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        return data;
    }

    async updateCampaign(campaign: FormData) {
        campaign.append('_method', 'PUT');

        const {data} = await axios.post(
            '/operator/v4/waapi/campaign/' + campaign.get('id'),
            campaign,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        )
        return data;
    }

    async deleteCampaign(campaign: number) {
        const {data} = await axios.delete('/operator/v4/waapi/campaign/' + campaign)
        return data;
    }

    async sendCampaign(campaign: FormData) {
        const {data} = await axios.post('/operator/v4/waapi/submit', campaign, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        return data;
    }

    async uploadContact(campaignId: number, token: string) {
        const {data} = await axios.post('/operator/v4/waapi/campaign/' + campaignId + "/upload-contact/" + token)
        return data;
    }

    async uploadContacts(campaignId: number, tokens: string[]) {
        const {data} = await axios.post('/operator/v4/waapi/campaign/' + campaignId + "/upload-contacts/", {numbers: tokens})
        return data;
    }
}

export default new WaapiService();

